// removed by extract-text-webpack-plugin
module.exports = {"img":"styles-module__img____75F5"};


//////////////////
// WEBPACK FOOTER
// ./src/ui/common/rebranding/components/Image/styles.module.scss
// module id = 1436
// module chunks = 147